/** Vertical spacing between stacked inputs in profile / settings forms. */
export const formFieldsStackSx = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  alignItems: "stretch",
  width: "100%",
}

/** Stronger visible borders on outlined inputs (settings dialogs + cards). */
export const outlinedInputBorderSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "background.paper",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: 1,
    borderColor: (theme) =>
      theme.palette.mode === "dark"
        ? theme.palette.grey[600]
        : theme.palette.grey[500],
  },
  "& .MuiOutlinedInput-root:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline":
    {
      borderColor: (theme) =>
        theme.palette.mode === "dark"
          ? theme.palette.grey[500]
          : theme.palette.grey[700],
    },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWidth: 2,
  },
  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "action.disabledBackground",
  },
}
